import { Tour } from '@core/models';
import { TourStatus } from '@core/enums';

export const TOURS: Tour[] = [];
